/**
 * Error messages the REST interceptor (`providers/restQuery.provider`) rejects a request with when
 * no HTTP response came back. They are i18n keys, translated where the error is surfaced.
 */
export const TIMEOUT_ERROR_KEY = 'error.timeout'
export const NETWORK_ERROR_KEY = 'error.network'

/**
 * Error the REST interceptor rejects an HTTP error response with. It is a plain `Error` (same
 * message as before) that also carries the HTTP status, so callers can tell a 404 from a 500.
 * `name` is deliberately left to `'Error'`: boundaries display `error.toString()` ("Error: …").
 */
export class ApiError extends Error {
  status: number
  code?: string

  constructor(message: string, status: number, code?: string) {
    super(message)
    this.status = status
    this.code = code
  }
}

/** Narrows `e` to `ApiError`, optionally checking the HTTP status (`isApiError(e, 404)`). */
export const isApiError = (e: unknown, status?: number): e is ApiError =>
  e instanceof ApiError && (status === undefined || e.status === status)
